const { Box, Typography, Icon } = require('@mui/material')
const { default: EmployeeList } = require('module/payroll/global-components/EmployeeList')

export const PayrollSummaryTableHeader = [
  {
    Header: (props) => {
      const { column } = props
      return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 1,
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="subtitle2">Employee</Typography>
          {column.isSorted ? (
            column.isSortedDesc ? (
              <Icon sx={{ fontSize: '32px', color: 'alternate.main' }}>arrow_drop_up</Icon>
            ) : (
              <Icon sx={{ fontSize: '32px', color: 'alternate.main' }}>arrow_drop_down</Icon>
            )
          ) : (
            <Icon
              sx={{
                fontSize: '32px',
                color: 'gray-inactive-button.main',
              }}
            >
              arrow_drop_down
            </Icon>
          )}
        </Box>
      )
    },
    accessor: 'name',
    Cell: (props) => {
      const { cell } = props
      return (
        <EmployeeList
          avatar={cell.row.original.avatar}
          sxContent={{ maxWidth: '300px' }}
          sx={{ minWidth: '350px' }}
          name={cell.row.original.name}
          position={cell.row.original.position}
        />
      )
    },
  },
  {
    Header: (props) => {
      const { column } = props
      return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 1,
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="subtitle2">Gross salary (RM)</Typography>
          {column.isSorted ? (
            column.isSortedDesc ? (
              <Icon sx={{ fontSize: '32px', color: 'alternate.main' }}>arrow_drop_up</Icon>
            ) : (
              <Icon sx={{ fontSize: '32px', color: 'alternate.main' }}>arrow_drop_down</Icon>
            )
          ) : (
            <Icon
              sx={{
                fontSize: '32px',
                color: 'gray-inactive-button.main',
              }}
            >
              arrow_drop_down
            </Icon>
          )}
        </Box>
      )
    },
    accessor: 'salary.gross',
    sortType: (prev, curr) => {
      if (
        parseFloat(prev?.original?.salary?.gross?.replace(/,/g, '')) >
        parseFloat(curr?.original?.salary?.gross?.replace(/,/g, ''))
      ) {
        return 1
      } else if (
        parseFloat(prev?.original?.salary?.gross?.replace(/,/g, '')) <
        parseFloat(curr?.original?.salary?.gross?.replace(/,/g, ''))
      ) {
        return -1
      } else {
        return 0
      }
    },
  },
  {
    Header: 'Income tax (RM)',
    accessor: 'mtd.nett_mtd',
    disableSortBy: true,
  },
  {
    Header: () => {
      return (
        <Box display="flex" flexDirection="column" width="110px">
          <Typography variant="subtitle2">EE EPF (RM)</Typography>
          <Typography variant="subtitle2">ER EPF (RM)</Typography>
        </Box>
      )
    },
    accessor: 'epf',
    Cell: (props) => {
      const { value } = props
      return (
        <Box display="flex" flexDirection="column">
          <Typography>{value.employee}</Typography>
          <Typography>{value.employer}</Typography>
        </Box>
      )
    },
    disableSortBy: true,
  },
  {
    Header: () => {
      return (
        <Box display="flex" flexDirection="column">
          <Typography variant="subtitle2">EE EIS (RM)</Typography>
          <Typography variant="subtitle2">ER EIS (RM)</Typography>
        </Box>
      )
    },
    accessor: 'eis',
    Cell: (props) => {
      const { value } = props
      return (
        <Box display="flex" flexDirection="column" width="110px">
          <Typography>{value.employee}</Typography>
          <Typography>{value.employer}</Typography>
        </Box>
      )
    },
    disableSortBy: true,
  },
  {
    Header: () => {
      return (
        <Box display="flex" flexDirection="column" width="110px">
          <Typography variant="subtitle2">EE SOCSO (RM)</Typography>
          <Typography variant="subtitle2">ER SOCSO (RM)</Typography>
        </Box>
      )
    },
    accessor: 'socso',
    Cell: (props) => {
      const { value } = props
      return (
        <Box display="flex" flexDirection="column">
          <Typography>{value.employee}</Typography>
          <Typography>{value.employer}</Typography>
        </Box>
      )
    },
    disableSortBy: true,
  },
  {
    Header: 'EE SKBBK (RM)',
    accessor: 'skbbk.employee',
    disableSortBy: true,
  },
  {
    Header: 'Claim (RM)',
    accessor: 'salary.claim',
    disableSortBy: true,
  },
  {
    Header: (props) => {
      const { column } = props
      return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 1,
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="subtitle2">Net pay (RM)</Typography>
          {column.isSorted ? (
            column.isSortedDesc ? (
              <Icon sx={{ fontSize: '32px', color: 'alternate.main' }}>arrow_drop_up</Icon>
            ) : (
              <Icon sx={{ fontSize: '32px', color: 'alternate.main' }}>arrow_drop_down</Icon>
            )
          ) : (
            <Icon
              sx={{
                fontSize: '32px',
                color: 'gray-inactive-button.main',
              }}
            >
              arrow_drop_down
            </Icon>
          )}
        </Box>
      )
    },
    accessor: 'salary.nett',
    Cell: (props) => {
      const { value, row } = props
      return (
        <Typography
          sx={{
            color: row.original.status === 1 && 'yellow-01.main',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
        >
          {value}
        </Typography>
      )
    },
    sortType: (prev, curr) => {
      if (
        parseFloat(prev?.original?.salary?.nett?.replace(/,/g, '')) >
        parseFloat(curr?.original?.salary?.nett?.replace(/,/g, ''))
      ) {
        return 1
      } else if (
        parseFloat(prev?.original?.salary?.nett?.replace(/,/g, '')) <
        parseFloat(curr?.original?.salary?.nett?.replace(/,/g, ''))
      ) {
        return -1
      } else {
        return 0
      }
    },
  },
]
